export default class Config {
    static getAllPagesConfig() {
        return new Promise((resolve) => {
            const appConfig = this.getPageConfig('app', './config/AppConfig.json');
            const onePage = this.getPageConfig('onePage', './config/PagesConfig/OnePage.json');
            const investments = this.getPageConfig('investments', './config/PagesConfig/Investments.json');
            const opportunity = this.getPageConfig('opportunity', './config/PagesConfig/Opportunity.json');
            const performanceDetail = this.getPageConfig('performanceDetail', './config/PagesConfig/PerformanceDetail.json');
            const performanceGeneral = this.getPageConfig('performanceGeneral', './config/PagesConfig/PerformanceGeneral.json');
            Promise.all([
                appConfig,
                onePage,
                investments,
                opportunity,
                performanceDetail,
                performanceGeneral
            ]).then((values) => {
                const config = {};
                for (let i = 0; i < values.length; i += 1) {
                    const item = values[i];
                    config[item.configName] = item;
                }
                resolve(config);
            });
        });
    }

    static getPageConfig(name, path) {
        return new Promise((resolve) => {
            fetch(path).then((response) => {
                response.json().then((res) => {
                    const data = res;
                    data.configName = name;
                    resolve(data);
                });
            });
        });
    }
}
